export const EnterPressClassSelector = 'dn-enterpress';
